module.exports = __webpack_public_path__ + "Roboto-Bold.eed9aab5449cc9c8430d.woff";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/dist/fonts/roboto/Roboto-Bold.woff
// module id = 605
// module chunks = 2